import React, { useState } from 'react'
import EditIcon from 'assets/images/loans/edit.svg'
import { UseMutateFunction } from 'react-query'
import posthog from 'posthog-js'
interface IBodyProps {
    name: string
    bankBalance: number
    interval: string
    shareValue: number
    dayOfDuetion: number
    type: string
    notificationAnnounce: string
    smsAnnounce: string
    id: string | undefined
    refetch: () => void
    imageId: number
    mutate: UseMutateFunction<any, unknown, ISettingImagePayload, unknown>
}
export default function Name({
    name,
    bankBalance,
    interval,
    shareValue,
    dayOfDuetion,
    type,
    notificationAnnounce,
    smsAnnounce,
    id,
    refetch,
    imageId,
    mutate,
}: IBodyProps) {
    const [isSelectedName, setIsSelectedName] = useState<boolean>(false)
    const [nameValue, setNameValue] = useState<string>(name)
    return (
        <div>
            {isSelectedName ? (
                <div className=" mx-3">
                    <p className=" text-sm text-gray-4 my-2">نام صندوق</p>
                    <div className=" flex justify-between">
                        <input
                            type="text"
                            value={nameValue}
                            onChange={(e) => setNameValue(e.target.value)}
                            className=" outline-none"
                        />
                        <p
                            className=" text-green-1"
                            onClick={() => {
                                setIsSelectedName(false)
                                const payload: ISettingImagePayload = {
                                    name: nameValue,
                                    bankBalance,
                                    interval,
                                    shareValue,
                                    dayOfDuetion,
                                    type,
                                    notificationAnnounce,
                                    smsAnnounce,
                                    imageId,
                                    id,
                                }
                                posthog.capture('fund_setting_name_saved', {
                                    fund_id: id,
                                })
                                mutate(payload)
                            }}
                        >
                            اعمال
                        </p>
                    </div>
                    <hr className=" w-full my-1" />
                </div>
            ) : (
                <div className=" mx-3">
                    <p className=" text-sm text-gray-4 my-2">نام صندوق</p>
                    <div className=" flex justify-between">
                        <p>{name}</p>
                        <img
                            src={EditIcon}
                            alt="edit"
                            className=" w-5 h-5"
                            onClick={() => setIsSelectedName(true)}
                        />
                    </div>
                    <hr className=" w-full my-1" />
                </div>
            )}
        </div>
    )
}
